function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShell = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M29.4 27.6H2.5V4.5h26.9Zm-25.9-1h24.9V5.5H3.5Z",
  style: {
    fill: "#d9b400"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m6.077 19.316-.555-.832 4.844-3.229-4.887-4.071.641-.768 5.915 4.928zM12.7 18.2h7.8v1h-7.8zM2.5 5.5h26.9v1.9H2.5z",
  style: {
    fill: "#d9b400"
  }
}));
export default SvgShell;